import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LockScreenPage } from './lock-screen.component';

const routes: Routes = [
  {
    path: 'lockscreen',
    component: LockScreenPage,
    data: {
      title: "Iniciar sesión"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LockScreenPageRoutingModule { }
